import { GeneratorFormState } from '../components/_organisms/DesignerTabPane/PromptsTab/GeneratorForm';
import {
  AIResourceTypes,
  Prompt,
  PromptInput,
  PromptInputData,
  promptModels,
  PromptSingleTestCaseResult,
} from '../services/backendService/types';
import { isDevelopment } from './client';

export const MAX_LIMIT_LEARNING_OBJECTIVE = 200;
export const MAX_LIMIT_PROMPT = 80;
export const MAX_LIMIT_UPLOADEDTEXT = 6000;

export const validSlidesFileTypes = [
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', //pptx
  'application/pdf',
  'pptx',
  'ppt',
  'key',
  'pdf',
];

/** How to add a new generative image model */
export const textResources = [AIResourceTypes.openai];

export const imageResources = [
  AIResourceTypes.unsplash,
  AIResourceTypes.openaiImage,
  // AIResourceTypes.midjourney,
];

export const urlGenerativeImages = [AIResourceTypes.unsplash] as string[];
export const fileGenerativeImages = [
  AIResourceTypes.openaiImage,
  // AIResourceTypes.midjourney,
];

export const availableImageModels = [
  {
    displayName: 'Unsplash',
    value: promptModels.unsplash,
  },
  {
    displayName: 'DALL·E 3',
    value: promptModels.dalle3,
  },
  // {
  //   displayName: 'Midjourney',
  //   value: promptModels.midjourney,
  // },
];

export const isGenerativeImagePrompt = (prompt: Prompt) => {
  return (imageResources as string[]).includes(prompt.promptOutput.resource.type);
};
export const isGenerativeTextPrompt = (prompt: Prompt) => {
  return (textResources as string[]).includes(prompt.promptOutput.resource.type);
};

export const getFullLessonGeneratorUrl = () => {
  if (isDevelopment()) {
    return '/generators/Fun%20debate%20practice/g/7e8a14e3-6fdf-4971-b654-8e444e0e1fbb';
  }
  return '/generators/Full-lesson/g/753d7c32-4f9b-42bf-bb53-12419c28425d';
};
export const generatorFormStateToUserInputFormData = (
  formState: GeneratorFormState,
  promptInputs: PromptInput[],
): PromptInputData[] => {
  return promptInputs.map(input => {
    if (input.type === 'slidesUpload' || input.type === 'fileUpload') {
      const value = formState?.[input.id];
      if (typeof value === 'string' || typeof value === 'number') {
        throw new Error('Invalid value for file or slide uploads');
      }

      return {
        id: input.id,
        type: input.type,
        fileType: value.fileType,
        value: value.filePath,
      };
    }

    return {
      id: input.id,
      type: input.type,
      value: (formState?.[input.id] || input.defaultValue || '') as string,
    };
  });
};

export const SINGLE_TESTCASE_CACHE_KEY = '@curipod_v1_generate_single_prompt_testcase';
export const storePromptSingleTestcase = (
  promptId: string,
  promptOutput: PromptSingleTestCaseResult,
) => {
  if (!promptOutput) return;
  const expiration = new Date().getTime() + 1000 * 60 * 60 * 24; // 1 day
  localStorage.setItem(
    `${SINGLE_TESTCASE_CACHE_KEY}_${promptId}`,
    JSON.stringify({
      output: promptOutput,
      expiration,
    }),
  );
};

export const clearStoredPromptSingleTestcase = (promptId: string) => {
  localStorage.removeItem(`${SINGLE_TESTCASE_CACHE_KEY}_${promptId}`);
};

export const getStoredPromptSingleTestcase = (promptId: string) => {
  const storedData = localStorage.getItem(`${SINGLE_TESTCASE_CACHE_KEY}_${promptId}`);
  if (storedData) {
    try {
      const parsedData = JSON.parse(storedData) as {
        expiration: number;
        output: PromptSingleTestCaseResult;
      };
      if (parsedData && parsedData.expiration > new Date().getTime()) {
        return parsedData.output;
      }
      clearStoredPromptSingleTestcase(promptId);
    } catch (error) {
      clearStoredPromptSingleTestcase(promptId);
    }
  }
  return undefined;
};
